import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=1bf401f0&scoped=true&"
import script from "./examination.vue?vue&type=script&lang=js&"
export * from "./examination.vue?vue&type=script&lang=js&"
import style0 from "./examination.vue?vue&type=style&index=0&id=1bf401f0&scoped=true&lang=scss&"
import style1 from "./examination.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf401f0",
  null
  
)

export default component.exports